/**
 * Descripción: Gestor de Rutas VUE-ROUTER
 *
 * @displayName index
 */

import Vue from 'vue';
import VueRouter from 'vue-router';
import paths from './path';

Vue.use(VueRouter);

const routes = [...paths];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
